module.exports = __webpack_public_path__ + "static/media/fb3.5d7da4fa.png";